var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCityback2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1989.9 1989.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{filter:url(#outer-glow-1);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:#e0c09f;opacity:.69;}.cls-2{filter:url(#outer-glow-2);}.cls-3{filter:url(#outer-glow-4);}.cls-6{fill:#3c3c3c;stroke:#646464;stroke-miterlimit:10;stroke-width:5px;}.cls-4{filter:url(#outer-glow-3);}.cls-7{opacity:.86;}.cls-8{opacity:.39;}.cls-9{fill:#696969;}.cls-10{opacity:.22;}.cls-11{fill:#333;}.cls-12{fill:#646464;}.cls-13{fill:gray;}.cls-14{fill:#fffbf4;opacity:.1;}.cls-15{fill:#5a5a5a;}.cls-5{filter:url(#outer-glow-5);}.cls-16{fill:#191919;}.cls-17{fill:#1a1a1a;}.cls-18{fill:#53565a;}.cls-19{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e8c6a9",
    floodOpacity: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e8c6a9",
    floodOpacity: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e8c6a9",
    floodOpacity: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1120.71,
    y1: 1764.97,
    x2: 1120.71,
    y2: 1573.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e8c6a9",
    floodOpacity: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e8c6a9",
    floodOpacity: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M0,994.77C8.9,382.97,445.37,0,994.77,0s994.77,445.37,994.77,994.77-411.24,555.2-960.64,555.2S-1.09,1069.99,0,994.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 584.9,
    y: 280.97,
    width: 148,
    height: 148,
    rx: 70.97,
    ry: 70.97
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M354.08,397.17c11.37,7.55,26.54,10.54,39.73,13.06,22.2,4.25,44.82,6.7,67.34,8.42,47.16,3.6,94.7,3.67,141.92,1.07,24.22-1.33,48.4-3.54,72.38-7.22h-11.96c58.73,11.92,118.6,18.61,178.27,23.65,33.15,2.8,66.44,5.45,99.73,5.77,16.32,.16,32.61-.38,48.8-2.55,13.02-1.75,29.85-4.69,36.5-17.75s1.92-26.15-9.52-34.01c-5.31-3.65-12.13-5.61-18.35-7.19-17.14-4.36-34.91-6.39-52.39-8.8v43.39c17.87-4.47,43.83-9.32,49.65-29.82,4.46-15.69-7.85-27.78-21.34-32.5-3.29-1.15-6.72-1.82-10.15-2.39-24.5-4.08-50-5.18-74.79-3.69-12.13,.73-26.41,1.33-36.42,9.06-13.69,10.57-11.88,30.96,2.65,39.9,6.22,3.83,13.89,5.5,21,6.76,33.35,5.94,67.87,6.68,101.67,6.51,34.65-.17,69.68-1.65,103.87-7.57h-11.96c35.68,5.99,71.46,10.48,107.69,10.4,17.06-.04,34.08-.84,50.97-3.34,6.11-.9,12.68-2.17,17.94-5.58,15.7-10.16,14.83-31.55-.57-41.41-7.38-4.73-17.14-5.67-25.56-6.76-9.18-1.19-18.42-1.66-27.68-1.38-10.16,.3-19.82,2.27-27.41,9.51-11.53,11.02-7.77,30.24,5.37,38.02s31.57,8.75,46.72,9.74c19.57,1.28,39.38,.81,58.88-1.23,13.82-1.44,30.78-2.44,42.89-10.23s15.8-22.05,8.83-34.36c-4.55-8.03-13.6-12.07-21.98-14.71-17.06-5.39-35.78-6.69-53.52-8.02-18.9-1.42-37.86-1.95-56.8-2.02-9.85-.04-19.7,.07-29.55,.3-9.01,.21-17.82-1.03-26.78-2-17.93-1.94-35.86-3.8-53.82-5.45-38.8-3.57-77.7-6.1-116.66-6.98-37.02-.83-74.13-.09-111.03,3.04-15.61,1.32-31.25,3.04-46.68,5.79-9.73,1.74-20.43,3.88-28.97,9.12-5.76,3.53-12.12,9.75-13.13,16.8,7.23-5.51,14.46-11.01,21.7-16.52-31.55-2.93-63.15-5.61-94.85-5.67-14.67-.03-29.37,.38-43.98,1.67-12.34,1.08-26.63,1.72-37.84,7.73s-16.02,18.94-11.16,30.46c3.62,8.58,10.95,13.11,19.5,15.9,6.39,2.09,13.41,2.75,20.03,3.53,7.56,.89,15.18,1.24,22.79,1.2,14.89-.08,30.12-1.47,44.6-5.01,13.97-3.41,31.61-8.93,39.36-22.09,6.16-10.46,4.15-24.41-4.83-32.64-5-4.58-10.76-7.17-17.12-9.38-11.56-4.02-24.24-5.36-36.3-6.77-29.16-3.39-59.22-3.58-88.4-.2-10.86,1.26-24.03,2.09-33.67,8.07-10.29,6.38-15.29,18.62-10.45,30.09,3.4,8.05,9.95,12.34,17.86,15.21,10.31,3.75,22.12,4.37,32.95,5.22,12.77,1,25.66,1.23,38.44,.34,7.59-.53,15.68-1.05,22.96-3.41,12.98-4.21,23.15-15.52,19.38-30.11-5.19-20.08-30.52-20.59-47.2-20.21-7.97,.18-15.91,1.06-23.77,2.34-5.33,.87-11,2.3-15.58,5.23-12.73,8.14-16.01,25.82-4.92,37,4.96,5,12.06,7.5,18.81,8.96,15.35,3.32,31.31,4.45,46.94,5.77,15.03,1.27,30.08,2.41,45.13,3.43,31.14,2.12,62.3,3.76,93.49,5,65.88,2.63,131.83,3.54,197.76,2.83,33.57-.36,67.15-1.06,100.69-2.52s64.97-3.44,97.11-8.35c13.35-2.04,26.58-4.66,38.9-10.37,16.63-7.7,23-28.33,9.96-42.52-6.73-7.33-17.32-10.23-26.75-12.12-13.25-2.64-26.82-4.06-40.28-5.01-14.27-1.01-28.61-1.37-42.91-1.04-15.4,.36-31.44,1.09-46.46,4.71-8.09,1.95-15.99,5.88-20.31,13.33-7.47,12.88-.83,28.36,12.21,33.87,9.85,4.16,21.21,4.57,31.79,5,11.17,.45,22.48,.17,33.48-2s17.5-14.39,16.12-24.69c-1.42-10.56-10.87-20.04-22.1-19.51-32.19,1.53-64.38,3.96-96.34,8.17-24.15,3.17-48.64,6.53-71.96,13.82-11.22,3.5-19.55,15.84-15.71,27.68,3.65,11.28,15.65,19.47,27.68,15.71,9.37-2.93,18.95-5.12,28.58-7.01,5.88-1.16,11.78-2.19,17.7-3.14,3.2-.51,6.4-1,9.61-1.47,1.66-.24,3.32-.47,4.99-.71,1.74-.24,.96-.14-2.35,.31,.98-.13,1.96-.26,2.95-.39,31.48-4.08,63.17-6.47,94.86-7.97-1.99-14.73-3.99-29.46-5.98-44.2-1.01,.2-4.91,.76-.25,.13s.25-.08-.76,0c-2.13,.18-4.27,.29-6.41,.35-5.09,.16-10.19,.09-15.28-.14-2.28-.11-4.55-.25-6.82-.43-1.23-.1-2.46-.22-3.68-.35-2.16-.23-5.79-1.53,1.72,.27-1.51-.36-3.07-.48-4.58-.86-.56-.14-1.14-.38-1.71-.49-2.03-.74-.65-.16,4.12,1.75-4.73-2.84-1.68,1.2,9.14,12.11v11.96l-5.37,9.07c-4.1,2.86-5.19,3.75-3.29,2.68-6.22,3.47-4.73,1.8-2.5,1.19s4.31-1.09,6.51-1.49c1.03-.19,3.2-.14,4.08-.66l-3,.4c1.05-.13,2.1-.26,3.16-.38,3.44-.38,6.88-.68,10.33-.91,12.66-.86,25.37-.99,38.06-.66,11.86,.31,23.73,1.03,35.53,2.33,1.95,.22,10.98,1.79,2.95,.31,1.92,.35,3.87,.57,5.8,.9,4.15,.7,8.3,1.5,12.34,2.66,1.29,.37,2.54,.89,3.82,1.24-.15-.04-6.38-2.54-2.09-.73,2.92,1.23-4.75-4.17-2.74-2.11-3.61-3.7-5.59-8.61-5.59-13.79s2.03-10,5.64-13.79c-2.63,2.76,5.25-3.09,2.38-1.77-.38,.18-.83,.46-1.2,.69-1.86,1.14-3.93,.72,2.43-.9-1.92,.49-3.8,1.41-5.7,1.99-5.07,1.54-10.27,2.68-15.47,3.69-3.15,.61-6.32,1.15-9.49,1.65-1.71,.27-3.41,.51-5.12,.77-5.99,.91,4.99-.58-1.2,.16s-12.06,1.4-18.11,1.98c-13.34,1.28-26.71,2.22-40.08,2.98-57.15,3.26-114.49,3.94-171.72,3.85-56.94-.09-113.88-1.37-170.76-3.98-29.66-1.36-59.31-3.1-88.93-5.29-14.76-1.09-29.54-2.2-44.27-3.71-3.51-.36-7.02-.78-10.53-1.19s5.72,.88,.78,.1c-1.79-.28-3.59-.55-5.38-.87-2.54-.46-5.09-.95-7.57-1.69-.77-.23-1.59-.64-2.37-.79,4.24,1.94,5.44,2.41,3.61,1.43,3.62,3.32,4.82,4.23,3.62,2.72l5.79,9.93c12.41,31.08-17.82,27.65-8.7,23.38,0,0-6.05,1.9-3.46,1.54,1.65-.23,3.34-.9,4.99-1.21,.93-.18,1.86-.32,2.79-.48,4.38-.78-4.43,.45-1.61,.22,2.55-.21,5.09-.5,7.65-.65,5-.29,10.03-.34,15.04-.09,1.49,.08,2.97,.2,4.46,.31,4.44,.33-2.83-.81-.66-.13,.83,.26,1.89,.44,2.74,.59l.84,.26c-6.57-1.96-11.04-6.62-13.42-13.98v-11.96l9.4-12.22c-1.16,.65-.66,.47,1.48-.53,4.3-1.79,1.18-.48,.22-.25-1.58,.38-3.16,.71-4.75,1.05-4.79,1.03,4.11-.33,.62-.06-1.31,.1-2.61,.27-3.92,.37-2.26,.18-4.53,.32-6.8,.43-8.95,.41-17.94,.31-26.88-.17-3.98-.22-7.96-.51-11.93-.9-1.81-.18-3.62-.43-5.43-.61-3.02-.31,6.19,.94,2.07,.27-1.03-.17-2.06-.32-3.09-.5-2.53-.45-5.08-.94-7.54-1.69-3.96-1.2,1.09,.57,2.5,1.23-.35-.17-.69-.34-1.03-.54-1.6-.99-.34,0,3.81,2.97,4.29,3.87,5.33,8.83,3.14,14.9v10.79c-1.76,2.99-4.12,5.36-7.11,7.11,.26-.16,.5-.33,.78-.47,1.93-.99-4.12,1.54-3.86,1.59,.35,.07,1.19-.44,1.56-.55,2.69-.77,5.4-1.41,8.16-1.91,1.84-.33,3.7-.53,5.54-.88-.21,.04-6.07,.75-2.31,.33,.86-.1,1.72-.2,2.58-.3,4.72-.52,9.45-.91,14.18-1.22,20.9-1.36,41.94-1.22,62.81,.55,4.44,.38,9.31,1.6,13.75,1.46-.38,.01-5.63-.82-1.81-.23,.89,.14,1.77,.26,2.66,.4,2.27,.36,4.53,.75,6.78,1.2,3.13,.61,6.24,1.31,9.31,2.18,1.26,.36,2.52,.74,3.76,1.17,.49,.17,.97,.37,1.47,.53,3.24,1.05-5.43-2.81-2.83-1.18,.64,.4,1.7,1.13,2.41,1.39-2.35-.84-4.4-3.68-5.78-5.7-4.57-6.68-3.27-15.13,1.07-20.8l1.29-1.68c-1.56,1.45-.76,.87,2.4-1.74-.59,.23-1.38,.88-1.9,1.18-.73,.42-1.5,.76-2.23,1.17-3.89,2.16,4.27-1.44,0,.02-7.19,2.46-14.3,4.61-21.81,5.9-.86,.15-1.72,.27-2.57,.42-4.68,.8,4.44-.49,1.14-.14-2.29,.24-4.57,.51-6.86,.69-5.86,.48-11.75,.7-17.64,.68-5.03-.02-10.07-.21-15.08-.62-1.79-.15-4.19-.93-5.92-.59,3.88-.76,4.1,.6,1.31,.16-1.2-.19-2.39-.4-3.58-.63-1.52-.3-3.04-.64-4.54-1.07-.68-.19-1.35-.47-2.03-.64-2.49-.62,5.78,2.9,3.14,1.33-1.88-1.13,.3-.34,3.28,2.69l3.02,3.99c-1.08,8.53-2.15,17.05-3.23,25.58l-3.82,2.97c1.16-.61,.63-.41-1.57,.6-4.25,1.79-1.4,.58-.36,.31,2.7-.71,5.4-1.33,8.16-1.8,1.82-.31,7.97-.87,.37-.12,2.18-.22,4.35-.51,6.52-.72,47.11-4.59,94.65-.61,141.62,3.75,8.72,.81,20.41-7.5,21.7-16.52,.15-1.06,.81-2.18-.94,1.95-1.32,3.12-.73,2.98-4.06,6.27,2.35-2.32-3.08,2.41-3.25,2.34,.07,.03,1.78-1.07,1.9-1.15,3.75-2.35-4,1.45-2.35,.93,4.64-1.47,9.21-2.82,13.99-3.8,3.01-.62,6.03-1.16,9.05-1.66,1.67-.27,3.34-.53,5.01-.78,.77-.11,1.55-.22,2.32-.33,4.36-.64-5.33,.67-1.16,.16,8.51-1.05,17.04-1.95,25.58-2.66,41.24-3.46,82.7-3.93,124.05-2.61,42.16,1.35,84.23,4.63,126.2,8.85,19.52,1.97,39.43,5.6,59.04,5.16,21.25-.47,42.53-.38,63.78,.54,9.98,.43,19.96,1.05,29.91,1.98,2.17,.2,4.34,.42,6.51,.66,1.45,.16,2.89,.35,4.33,.51,3.57,.38-5.57-.85-.21-.04,4.55,.69,9.09,1.41,13.59,2.39,3.25,.7,6.5,1.5,9.65,2.59,.25,.08,2.05,.6,2.05,.76,0,.09-5.72-2.42-3.31-1.34,.39,.18,.74,.46,1.13,.63,2.77,1.24-4.81-4.17-2.91-2.24-4.28-4.36-5.01-8.27-5.02-14.13,0-5.52,.54-10.12,4.92-14.12,.76-.69,5.81-4.07,2.42-2.11-2.67,1.54,5.65-2.06,3.2-1.35-.63,.18-1.25,.44-1.88,.64-1.5,.47-3.02,.86-4.55,1.22-3.47,.81-6.99,1.4-10.51,1.96-1.39,.22-4.26,.43,1.9-.23-.95,.1-1.9,.24-2.86,.35-2.78,.33-5.57,.61-8.37,.86-10.6,.94-21.25,1.39-31.89,1.42s-21.82-.35-32.66-1.52c-.61-.07-2.21-.46-2.91-.34,4.1-.73,3.9,.56,1.22,.15-1.83-.28-3.65-.58-5.47-.94-1.55-.31-3.09-.64-4.62-1.04-.92-.24-3.48-1.52-4.41-1.37,1.08-.18,6.01,3.07,2.69,.96,11.51,7.34,13.01,25.23,1.72,33.88-3.61,2.77-2.03,1.48-1.03,.98,.4-.2-6.39,2.46-3.47,1.51,.12-.04,1.48-.32,1.62-.49-3.87,.44-4.36,.57-1.48,.38l1.79-.06c5.18-.16,10.38-.08,15.56,.22,2.62,.15,5.23,.36,7.84,.64,.96,.1,1.93,.25,2.89,.34-6.76-.63-2.21-.27-.72,0,1.66,.3,3.31,.63,4.93,1.06,2.73,.72,5.49,2.73-1.03-.81,.35,.19,.71,.34,1.05,.56-10.86-6.87-12.09-28.98-.07-35.88-1.94,1.12,6.51-2.05,3-1.33-.74,.15-1.46,.41-2.2,.59-1.13,.28-2.27,.51-3.42,.72-1.85,.35-8.3,.99-.08,.13-3.62,.38-7.23,.81-10.86,1.1-18.66,1.45-37.49,1.49-56.18,.64-10.35-.47-20.68-1.28-30.98-2.38-2.36-.25-4.71-.52-7.07-.8-1.02-.12-2.04-.25-3.06-.38-.53-.07-5.46-.92-1.5-.18s-.87-.13-1.42-.2c-.96-.14-1.92-.27-2.88-.41-2.35-.34-4.71-.7-7.06-1.06-4.09-.64-8.18-1.3-12.26-1.98-2.77-.46-5.53-.92-8.31-1.29-4.44-.6-8.67,.39-13.03,1.08-1.42,.22-2.85,.43-4.27,.64-4.17,.63,5.08-.63,2.08-.27-.96,.12-1.92,.25-2.87,.37-3.84,.47-7.69,.89-11.55,1.26-17.43,1.69-34.95,2.57-52.45,3.01-18.46,.46-36.95,.39-55.41-.27-8.94-.32-17.88-.79-26.8-1.45-3.94-.29-7.87-.63-11.8-1.01-2.22-.22-4.43-.45-6.65-.71-.27-.03-5.99-.82-2.15-.25,3.55,.52-1.99-.32-2.67-.43-4.02-.65-8.05-1.37-11.98-2.44-1.33-.36-2.83-1.14-4.19-1.34,4.5,.65,5.19,2.39,3.41,1.35l-.5-.31c4.61,2.91,7.67,6.87,9.18,11.89v11.96l-2.67,4.5c-.81,2.61-2.32,4.59-4.54,5.94-4.26,3.3,1.28,.04-3.25,1.97-3.88,1.65-1.65,.64-.71,.43,1.42-.32,2.82-.72,4.25-.98,.84-.16,1.68-.27,2.52-.42,3.25-.59-6.25,.7-2.81,.39,2.23-.21,4.45-.46,6.68-.62,9.67-.7,19.39-.77,29.08-.56s20.27,.73,30.35,1.76c2.07,.21,4.14,.49,6.21,.71,1.6,.17-6.4-.95-2.47-.31,1.08,.18,2.16,.34,3.24,.53,2.9,.51,5.69,1.24,8.52,2.03,3.39,.95-5.46-2.72-2.07-.78,.79,.45,2.35,1.66-.9-.77-3.63-2.16-5.03-5.81-4.22-10.95-3.76-5.14-3.79-9.77-.09-13.9,3.02-5.21,3.41-5.26,1.93-3.7,4.35-4.57,3.96-2.71,2.04-1.76-1.13,.56-2.45,1.08-3.51,1.75,4.17-2.64,3.43-1.39,1.67-.78-.93,.32-1.84,.66-2.77,.98-2.03,.69-4.08,1.32-6.13,1.93-4.57,1.34-9.17,2.53-13.79,3.69-9.2,2.3-16.95,12.06-16.52,21.7,.18,3.99,1.2,7.82,3.07,11.36,2.25,4.26,8.49,9.66,13.45,10.34,13.62,1.88,27.27,3.7,40.78,6.28,4.89,.93,9.77,1.95,14.56,3.31,2.03,.58,3.98,1.33,5.98,1.98-6.84-2.2-4.5-2.07-2.76-1.05,3.59,2.12-4.34-3.89-2.42-1.94-7.49-7.62-7.54-20.56,.16-28.27-1.95,1.96,5.76-3.5,3.02-2.26-.53,.24-1.24,.59-1.73,.91,4.94-3.3,4.82-1.85,2.3-1.11-.96,.28-1.92,.57-2.9,.82-2.42,.61-4.88,1.02-7.33,1.47-5.1,.94,5.49-.53-.07,.03-1.72,.17-3.44,.38-5.16,.53-2.75,.25-5.5,.45-8.26,.61-6.68,.39-13.36,.57-20.05,.62-26.75,.2-53.49-1.58-80.16-3.52-27.28-1.99-54.52-4.4-81.71-7.36-12.73-1.39-25.45-2.89-38.15-4.55-1.5-.2-3.1-.28-4.58-.6,.49,.11,5.45,.75,1.45,.19-2.98-.41-5.95-.82-8.93-1.25-5.77-.82-11.54-1.68-17.3-2.58-10.76-1.68-21.51-3.5-32.22-5.5-4.55-.85-9.08-1.84-13.64-2.66-5.87-1.06-11.06-.1-16.79,.72-1.56,.22-6.21,.67,.97-.12-1.51,.17-3.02,.39-4.53,.58-49.71,6.1-100.3,7.16-150.33,5.65-15.13-.45-30.25-1.23-45.34-2.42-7.12-.56-14.24-1.21-21.35-1.98-3.57-.38-7.14-.8-10.7-1.24-1.44-.18-6.5-1.21,.14,.04-1.86-.35-3.76-.52-5.63-.8-10.33-1.53-20.66-3.33-30.78-5.95-3.73-.97-7.45-2.05-11.07-3.39-5.73-2.13,5.26,2.58,.19,.08-1.19-.59-2.34-1.24-3.45-1.97-9.83-6.53-25.33-2.25-30.78,8.07-5.97,11.3-2.41,23.82,8.07,30.78h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1589.25,348.66l1.75-19.41c.3-3.32,.6-6.63,.9-9.95,.26-2.91,.67-5.86,.67-8.79,0-.61-.02-1.22-.08-1.82-.18-1.85-.51-3.85-.74-5.59-.22-1.65-.4-3.78-.79-5.59-.13-.62-.3-1.22-.52-1.81-1.32-3.52-2.58-7.13-4.48-10.39-4.36-7.49-10.08-12.5-17.19-17.26-1.04-.7-2.14-1.26-3.29-1.75-3.47-1.51-8.01-3.88-12.14-4.7-9.35-1.86-17.06-2.25-26.4,.15-4.13,1.06-8.1,2.92-11.87,4.9-1.03,.54-1.99,1.2-2.92,1.89-3.28,2.44-6.67,4.95-9.75,7.7-.9,.8-1.77,1.63-2.71,2.38l7.29-5.63c-1.32,1.01-2.75,1.82-4.27,2.49l8.6-3.63c-1.56,.65-3.16,1.11-4.82,1.36l9.57-1.29c-1.32,.17-2.61,.19-3.93,.04l9.57,1.29c-1.21-.17-2.36-.48-3.49-.95l15.89,60.17c1.16-.99,2.35-1.95,3.55-2.89l-7.29,5.63c6.21-4.79,12.96-8.82,20.18-11.9l-8.6,3.63c7.21-3.04,14.79-5.13,22.54-6.2l-9.57,1.29c8.57-1.15,17.29-1.09,25.86,.05l-9.57-1.29c7.03,.97,13.97,2.67,20.52,5.43l-8.6-3.63c6.05,2.59,11.34,6.3,16.59,10.22,2.55,1.91,5.1,3.82,7.76,5.56,5.21,3.41,10.87,5.62,16.65,7.98,1.71,.7,3.45,1.28,5.24,1.71,.93,.22,1.87,.4,2.81,.55,4.08,.63,8.2,1.29,12.33,1.58l9.57-1.29c4.68-1.11,8.77-3.26,12.24-6.44,2.7-1.6,4.86-3.75,6.46-6.46,3.18-3.48,5.33-7.56,6.44-12.24,.26-.9,.47-1.8,.61-2.73,.62-3.97,1.36-8,1.53-12.04,.21-4.96-.79-10.11-1.67-14.89-.36-1.95-.96-3.83-1.7-5.67-1.85-4.59-3.68-9.62-6.41-13.88s-6.06-8.5-9.49-12.39c-1.61-1.82-3.36-3.52-5.22-5.1-3.21-2.72-6.6-5.24-9.96-7.76-.94-.71-1.91-1.38-2.89-2.04-1.91-1.27-3.89-2.44-5.92-3.52s-4.28-2.15-6.48-3.1c-4.99-2.15-9.99-4.37-15.14-6.14-4.82-1.65-9.76-2.93-14.77-3.86-8.04-1.49-16.26-2.64-24.45-2.94-5.59-.2-11.18,.12-16.75,.62-12.66,1.14-25.39,3.17-38.11,1.54l9.57,1.29c-2.67-.36-5.31-.88-7.91-1.57-4.79-1.5-9.57-1.71-14.36-.64-4.79,.22-9.25,1.64-13.38,4.27-4.2,2.26-7.56,5.35-10.1,9.27-3.18,3.48-5.33,7.56-6.44,12.24l-1.29,9.57c.02,6.5,1.66,12.55,4.92,18.17l5.63,7.29c4.49,4.46,9.79,7.55,15.89,9.26,2.37,.63,4.78,1.13,7.21,1.48,5.41,.77,10.86,1.66,16.34,1.91,4.77,.22,9.55,.02,14.31-.35,9.73-.76,19.41-2.22,29.18-2.39,5.05-.09,10.09,.23,15.1,.89l-9.57-1.29c8.93,1.22,17.7,3.53,26.02,7.02l-8.6-3.63c5.8,2.46,11.35,5.5,16.35,9.33l-7.29-5.63c3.31,2.58,6.34,5.48,8.93,8.78l-5.63-7.29c1.98,2.56,3.66,5.32,4.92,8.31l-3.63-8.6c.91,2.23,1.57,4.54,1.9,6.93l-1.29-9.57c.25,1.97,.26,3.94,.03,5.92l1.29-9.57c-.15,1.13-.38,2.24-.7,3.34,11.57-8.81,23.14-17.62,34.71-26.43-.79-.06-1.58-.13-2.37-.24l9.57,1.29c-2.97-.42-5.84-1.23-8.61-2.38l8.6,3.63c-7.86-3.35-14.26-9.08-21.21-13.9-4.84-3.35-9.91-5.7-15.33-7.98s-11.14-4.53-17.1-5.87c-7.59-1.7-15.39-2.7-23.14-3.28-4.73-.35-9.49-.37-14.22-.03-12.6,.89-25.41,2.92-37.15,7.77-7.48,3.09-14.86,6.1-21.73,10.4s-12.74,8.96-18.63,13.96c-4.46,4.49-7.55,9.79-9.26,15.89-1.71,6.38-1.71,12.76,0,19.14,1.71,6.1,4.8,11.39,9.26,15.89,4.49,4.46,9.79,7.55,15.89,9.26,1.14,.47,2.27,.76,3.49,.95,3.53,.55,7.17,1.24,10.75,1.38,.59,.02,1.18,0,1.77-.04,3.63-.28,7.35-.83,10.94-1.45,.58-.1,1.15-.22,1.72-.37,3.86-1.02,8.33-3.22,11.49-4.64,.94-.42,1.85-.89,2.72-1.45,.43-.27,.84-.57,1.25-.87,2.75-2.02,5.56-4.1,8.15-6.33,1.44-1.25,2.81-2.57,4.32-3.75l-7.29,5.63c1.34-1.03,2.75-1.91,4.3-2.58l-8.6,3.63c1.26-.51,2.55-.85,3.9-1.04l-9.57,1.29c1.39-.16,2.76-.15,4.15,0l-9.57-1.29c1.65,.23,3.23,.66,4.77,1.28l-8.6-3.63c1.56,.66,3.01,1.49,4.35,2.52l-7.29-5.63c.9,.72,1.72,1.51,2.44,2.42l-5.63-7.29c.55,.74,1,1.52,1.39,2.35l-3.63-8.6c.44,1.04,.73,2.1,.91,3.22l-1.29-9.57c.4,2.97,0,5.97-.28,8.93l-.96,10.7c-.64,7.05-1.27,14.1-1.91,21.15-.19,4.96,.85,9.58,3.1,13.87,1.45,4.46,3.93,8.33,7.44,11.59,3.26,3.51,7.12,5.99,11.59,7.44,4.29,2.25,8.91,3.29,13.87,3.1l9.57-1.29c6.1-1.71,11.39-4.8,15.89-9.26l5.63-7.29c3.26-5.61,4.89-11.67,4.92-18.17h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1358.9,785.97h367v824.8c0,81.24-65.96,147.2-147.2,147.2h-219.8V785.97h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 963.9,
    y: 402.97,
    width: 367,
    height: 1337
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1544.86 716.97 1363.83 787.97 1725.9 787.97 1544.86 716.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1725.9 897.87 1358.9 533.77 1358.9 1261.97 1725.9 897.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M301.9,1211.97H941.9v546H405.49c-57.18,0-103.59-46.42-103.59-103.59v-442.41h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 353.9,
    y: 1070.97,
    width: 211,
    height: 564
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 616.9,
    y: 883.97,
    width: 325,
    height: 589
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1043.9,
    y: 319.97,
    width: 11,
    height: 564
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 534.9,
    y: 996.97,
    width: 11,
    height: 564
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 483.9,
    y: 1012.97,
    width: 11,
    height: 564
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 509.84,
    y: 965.59,
    width: 7.49,
    height: 80.5,
    transform: "translate(1374.91 275.37) rotate(76.75)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1011.9,
    y: 659.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 660.9,
    y: 912.97,
    width: 246,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 660.9,
    y: 1049.97,
    width: 246,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 660.9,
    y: 1186.97,
    width: 246,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 660.9,
    y: 1325.97,
    width: 246,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1116.9,
    y: 659.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 659.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1011.9,
    y: 774.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1116.9,
    y: 774.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 774.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1011.9,
    y: 889.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1116.9,
    y: 889.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1216.9,
    y: 889.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1011.9,
    y: 1004.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1116.9,
    y: 1004.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 1004.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1116.9,
    y: 1129.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 1244.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 1359.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 1474.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1216.9,
    y: 1129.97,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 924.4,
    y: 1225.47,
    width: 267,
    height: 536,
    rx: 15.18,
    ry: 15.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 963.9,
    y: 1104.97,
    width: 190,
    height: 190,
    rx: 7.62,
    ry: 7.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1012.16,
    y: 1077.97,
    width: 95.05,
    height: 190,
    rx: 5.39,
    ry: 5.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 739.9,
    y: 1411.97,
    width: 349,
    height: 349,
    rx: 150.2,
    ry: 150.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1168.9,
    y: 1571.97,
    width: 190,
    height: 190,
    rx: 7.62,
    ry: 7.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1168.9,
    y: 1530.97,
    width: 190,
    height: 190,
    rx: 51.41,
    ry: 51.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1316.9,
    y: 1096.97,
    width: 267,
    height: 664
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 575.9,
    y: 1333.97,
    width: 190,
    height: 428
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 692.9,
    y: 1267.97,
    width: 43,
    height: 333
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 405.9,
    y: 1571.97,
    width: 520,
    height: 190
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 405.9,
    y: 1434.97,
    width: 135,
    height: 220,
    rx: 46.63,
    ry: 46.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 462.9,
    y: 1423.97,
    width: 21,
    height: 333
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 624.9,
    y: 1307.97,
    width: 21,
    height: 333
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1052.9,
    y: 1012.97,
    width: 10,
    height: 333
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1526.9,
    y: 1058.97,
    width: 10,
    height: 333
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1371.04,
    y: 1073.88,
    width: 103.86,
    height: 37.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 421.11,
    y: 1434.84,
    width: 103.86,
    height: 37.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 421.11,
    y: 1434.84,
    width: 103.86,
    height: 37.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 454.41,
    y: 1635.73,
    width: 208.36,
    height: 9.48,
    transform: "translate(2199.07 1081.88) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1159.59,
    y: 1612.53,
    width: 208.36,
    height: 9.48,
    transform: "translate(2881.04 353.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "575.9 1332.97 765.9 1370.97 765.9 1294.97 575.9 1332.97"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 586.9,
    y: 1757.97,
    width: 989,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "454.9 1758.97 1426.9 1758.97 1251.9 1929.97 631.9 1871.97 454.9 1758.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 739.9,
    y: 753.99,
    width: 159,
    height: 158.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 771.9,
    y: 716,
    width: 4,
    height: 158.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 725.58,
    y: 715.18,
    width: 60.95,
    height: 2.09,
    transform: "translate(-148.59 200.26) rotate(-13.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 742.43,
    y: 715.63,
    width: 60.95,
    height: 2.09,
    transform: "translate(-148.22 204.28) rotate(-13.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 755.43,
    y: 716.63,
    width: 60.95,
    height: 2.09,
    transform: "translate(-148.08 207.4) rotate(-13.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 771.74,
    y: 708.67,
    width: 2.09,
    height: 16.67,
    transform: "translate(-143.99 1237.39) rotate(-72.44)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1117.9,
    y: 1573.97,
    width: 5.62,
    height: 191
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1100.87,
    y: 1552.99,
    width: 7.2,
    height: 39.15,
    transform: "translate(2677.04 468.09) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1071.56,
    y: 1728.3,
    width: 3.68,
    height: 47,
    transform: "translate(2825.2 678.4) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1091.9,
    y: 1752.97,
    width: 2.87,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1053.73,
    y: 1753.1,
    width: 2.87,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1072.15,
    y: 1724.71,
    width: 2.49,
    height: 47,
    transform: "translate(2821.61 674.81) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1072.15,
    y: 1721.62,
    width: 2.49,
    height: 47,
    transform: "translate(2818.52 671.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1348.52,1696.97c-8.15-1.36-16.28,10.51-20.69,6.53-3.62-3.27-.3-13.24,.25-16.71,1.96-12.32,.33-7.18-8.55-18.29-7.17-8.97,.2-12,.12-22.88-.03-4.55-3.44-12.21-1.9-16.36,3.4-9.13,12.33-3.89,17.44-7.29,13.42-8.93,6.44-40.4,30.4-28.62,5.78,2.84,13.85,11.96,18.97,13.41,9.16,2.59,9.95-6.26,17.32-6.29,15.14-.07,16.82,16.46,19.81,25.56,2.21,6.72,3.28,4.7,8.28,9.62,10.15,9.98,2.11,5.42-1.85,14.34-3.49,7.87,4.76,12.4,4.73,19.53-.04,9.19-7.19,9.53-11,17.19-3.2,6.43,.55,20.62-6.49,24.71-6.25,3.63-16.78-5.15-22.43-7.3-9.84-3.75-15.23-1.7-23.78-.88-8.22,.79-13.77-3.67-22.69-6.28h2.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1366.9,
    y: 1689.97,
    width: 18,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1138.9,
    y: 1735.97,
    width: 17.2,
    height: 27.5,
    rx: 4.52,
    ry: 4.52,
    transform: "translate(2294.99 3499.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 857.9,
    y: 803.97,
    width: 5,
    height: 131,
    transform: "translate(1729.86 9.07) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 795.21,
    y: 871.72,
    width: 5,
    height: 16.39,
    transform: "translate(1595.41 1759.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 920.51,
    y: 871.72,
    width: 5,
    height: 16.39,
    transform: "translate(1846.03 1759.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M685.94,776.97h115.96v112h-184v-43.96c0-37.55,30.49-68.04,68.04-68.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M787.84,859.7l80.23-69.47c5.29-4.58,2.05-13.26-4.94-13.26h-160.46c-6.99,0-10.23,8.68-4.94,13.26l80.23,69.47c2.84,2.46,7.05,2.46,9.89,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 864.03,
    y: 871.37,
    width: 5,
    height: 16.39,
    transform: "translate(1733.06 1759.12) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M593.36,1682.97h136.08c3.57,0,6.46,2.9,6.46,6.46v75.04h-149v-75.04c0-3.57,2.9-6.46,6.46-6.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 621.9,
    y: 1693.97,
    width: 3,
    height: 67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 658.9,
    y: 1693.97,
    width: 3,
    height: 67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 697.9,
    y: 1693.97,
    width: 3,
    height: 67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 657.9,
    y: 1678.97,
    width: 6,
    height: 128,
    transform: "translate(-1082.07 2403.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 660.4,
    y: 1621.47,
    width: 3,
    height: 146,
    transform: "translate(-1032.57 2356.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 658.9,
    y: 1618.97,
    width: 5,
    height: 141,
    rx: 1.57,
    ry: 1.57,
    transform: "translate(-1028.07 2350.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1506.98,
    y: 1727.48,
    width: 3.68,
    height: 47,
    transform: "translate(3259.8 242.16) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1527.32,
    y: 1752.14,
    width: 2.87,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1489.15,
    y: 1752.27,
    width: 2.87,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1507.57,
    y: 1723.89,
    width: 2.49,
    height: 47,
    transform: "translate(3256.2 238.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1507.57,
    y: 1720.79,
    width: 2.49,
    height: 47,
    transform: "translate(3253.11 235.48) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M871.15,1439.97h54.75v118h-147v-25.75c0-50.92,41.34-92.25,92.25-92.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1352.9,
    y: 1137.97,
    width: 194,
    height: 69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1352.9,
    y: 1232.97,
    width: 194,
    height: 69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1353.9,
    y: 1330.97,
    width: 194,
    height: 69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1353.9,
    y: 1428.97,
    width: 194,
    height: 69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 411.9,
    y: 1104.97,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M531.78,1690.38c17.07,4.11,7.1-7.51,11.87-14.82,5.31-8.13,17.52-9.62,26.24-11.9,8.8-2.31,21.67,.54,20.98-13.45-.56-11.33-15.62-9.91-17.46-20.72-1.48-8.67,11.8-15.13,6.59-24.39-6.71-11.93-25.15-.35-30.7-6.73-9.62-11.04,28.7-21.11,6.8-35.55-12.18-8.03-25.44,5.97-36.4,5.81-4.85-.07-8.1-5.77-12.25-5.95-2.15-.1-9.26,2.74-10.18,2.57-7.58-1.36-24.74-11.13-33.25-4.91-5.45,3.99-6.21,17.09-8.52,22.74-1.34,3.29-5.97,5.6-6.99,9.1-1.72,5.97,2.52,9.76,2.07,13.39-1.88,15.3-21.18,34.37-10.87,49.73,5.42,8.08,16.29,8.14,23.25,13.33,7.51,5.61,11.58,16.91,20.31,21.45,14.85,7.73,31.17,1.77,46.78,.29h1.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 500.9,
    y: 1655.97,
    width: 26,
    height: 113
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M545.33,1575.35c7.83,1.76,18.01,6.82,20.93,14.98,1.74,4.88-.79,8.31-2,12.83-2.88,10.75,9.93,11.97,14.72,19.45,1.55,2.42,4.8,7.37,4.66,10.37-.19,3.95-5.34,7.84-7.89,10.36-4.69,4.63-8,9.48-9.91,15.78-1.15,3.77-1.43,8.75-3.88,11.95-3.42,4.48-10.04,5.03-15.21,5.46-11.6,.95-22.6,.1-34.04-1.37-8.8-1.13-16.84-.97-25.71-.08-5.15,.52-10.19,1.7-15.32,2.53-4.82,.79-18.13,6.81-22.53,4.89-8.06-3.51-.5-25.15,.39-31.7,1.23-9.03,.72-17.91-3.11-26.24-4.15-9.02-8.88-15.24-6.44-25.99,1.83-8.05,9.07-20.2,17.17-22.67,7.82-2.39,15.74,.23,23.44-3.27,7.96-3.62,16.24-6.32,23.99-10.46,11.8-6.3,24.91,6.75,30.72,16.83l10.03-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M482.9,1596.76c-8.65-3.54-5.18,3.99-4.8,8.64,.25,3.06-2.29,6.16,.91,8.94,2.2,1.92,6.76,1.33,9.03-.22,3.23-2.2,1.91-5.1,3.56-7.33,2.38-3.21,6.62-2.48,6.3-7.83-.67-11.17-20.71-8.58-15-1.29v-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M520.72,1644.61c-2.95-7.02,.91-9.64,7.52-10.68,8.57-1.35,5.08,6.39,6.46,12.07-5.18,3.56-12.19,3.88-14.9-1.84l.91,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M535.76,1600.86c-5.69-.78-3.57,10.36,3.2,8.22,6-1.9,.2-7.27-3.2-9.13v.91Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1604.41,
    y: 1413.63,
    width: 208.36,
    height: 9.48,
    transform: "translate(3126.96 -290.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M405.9,1758.97h-51c-7-2-49-40-53-48v-179h104v227Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "500.9 1789.97 404.9 1787.97 405.9 1649.97 561.9 1758.97 500.9 1789.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 500.9,
    y: 1710.97,
    width: 26,
    height: 113
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M581.9,1882.97l-40-2c-59-28-125-67-187-122h0s227,0,227,0v124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M541.9,1880.97h0v-122H1632.9c-290,235-693,315-1091,122-2.82-1.37,2.84,1.33,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1583.9 1757.97 1426.9 1757.97 1447.9 1579.97 1583.9 1579.97 1583.9 1757.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1632.9,1758.97h-48s0-273,0-273h141l-77,160c-10,19,7,100-16,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1838.9,1520.97h0c-68.08,107-114.2,158-206,238h-56v-517l262,279"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1648.9,1355.97l271,3s-11,36-55,118l-26,44.08-190-128v-37.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1989.9,994.97c-4-238-71-433-219.25-622.57-1.69-2.16-5.12-1.7-6.34,.76h0c-.27,.53-.4,1.12-.4,1.71v979.28c0,2.11,1.71,3.82,3.82,3.82h150.51c1.6,0,3.04-1,3.59-2.5,26.97-73.73,56.09-151.5,67.09-310.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1622.9,
    y: 1391.97,
    width: 194,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1853.9,1487.97h5s21-39,21-39c21-39,27-56,27-56l-53-1v96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 202.9,
    y: 519.93,
    width: 4,
    height: 158.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 157.2,
    y1: 526.39,
    x2: 216.4,
    y2: 511.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 174.05,
    y1: 526.84,
    x2: 233.25,
    y2: 512.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 187.05,
    y1: 527.84,
    x2: 246.25,
    y2: 513.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 211.42,
    y1: 524.45,
    x2: 195.53,
    y2: 519.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1881.9,
    y: 1292.85,
    width: 1,
    height: 92.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1833.2,
    y1: 1299.3,
    x2: 1892.4,
    y2: 1284.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1850.05,
    y1: 1299.76,
    x2: 1909.25,
    y2: 1285.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1863.05,
    y1: 1300.76,
    x2: 1922.25,
    y2: 1286.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1887.42,
    y1: 1297.36,
    x2: 1871.53,
    y2: 1292.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1828.9,
    y: 1330.97,
    width: 43,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1791.9,
    y: 1291.16,
    width: 21,
    height: 89.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M49.9,670.97l255-91V1710.97h0c-24-29-446-373-255-1040h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120.9,1474.97l288,64v220h-54c-19-4-215.35-216-234-284h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M181.9,1542.97l203,42.68v167.32h-34.31c-13.69-2-163.69-164-193.69-214l25,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 62.9,
    y: 776.97,
    width: 166,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 62.9,
    y: 951.97,
    width: 166,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 62.9,
    y: 1121.97,
    width: 166,
    height: 111
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M314.4,1343.47l40.5,197.5-197.4-48.19h0c-7.6-68.81-7.6-74.81,1.82-107.22,10.73-36.89,48.36-67.43,62.68-81.56l92.4,39.46Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityback2);
export default __webpack_public_path__ + "static/media/cityback2.867923c7c6fa11c74bdd14d265f39888.svg";
export { ForwardRef as ReactComponent };